module.exports = __webpack_public_path__ + "static/media/card-swipe1.f7cb4eb4.jpg";